module.exports = __webpack_public_path__ + "img/5.d78fc403.png";